export default {
  DpAttemptsReport: {
    assessmentName: 'Name',
    type: 'Type',
    courseSection: 'Course - Section',
    date: 'Date',
    status: 'Status',
    score: 'Score',
    noReports: 'There are no reports to show yet'
  }
};